import {Space, Typography} from "@ui";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import useIsMobile from "@/hooks/useIsMobile";
import iconBell from "../../assets/images/icon-bell.svg";
import iconBellBlack from "../../assets/images/icon-bell-black.svg";

const {Title, Paragraph} = Typography;

const NotificationPrompt = ({
  onClose,
  onRequestPermission,
  pushSupported,
  userConsent = "default",
  isSubscribing = false,
  error = null,
}) => {
  const {t} = useTranslation();
  const isMobile = useIsMobile();

  // If notifications are not supported, don't show the modal
  if (!pushSupported) {
    return null;
  }

  // If the user has already granted permission, we don't need to show this
  if (userConsent === "granted") {
    return null;
  }

  return (
    <Space
      direction="vertical"
      style={{width: "100%", textAlign: "center", fontFamily: "var(--font-family)"}}
    >
      <img
        src={iconBell}
        alt="Notification"
        style={
          isMobile
            ? {width: "30.06px", height: "33px", marginTop: "10px"}
            : {width: "50.06px", height: "53px", marginTop: "20px", marginBottom: "0"}
        }
      />
      <Title
        level={4}
        style={
          isMobile
            ? {fontFamily: "var(--font-family)", fontSize: "18px", fontWeight: "500", marginBottom: "0"}
            : {fontFamily: "var(--font-family)", fontSize: "21px", fontWeight: "500", marginBottom: "0"}
        }
      >
        {t("notifications.prompt.title", "Recibe notificaciones importantes")}
      </Title>
      <Paragraph
        style={
          isMobile
            ? {fontFamily: "var(--font-family)", fontSize: "16px", fontWeight: "400", marginBottom: "10px"}
            : {fontFamily: "var(--font-family)", fontSize: "16px", fontWeight: "400", marginBottom: "35px"}
        }
      >
        {t(
          "notifications.prompt.description",
          "Activa las notificaciones para recibir alertas sobre promociones especiales, resultados de juegos y novedades."
        )}
      </Paragraph>

      {error && (
        <Paragraph type="danger">
          {t("notifications.prompt.error", "Ocurrió un error al activar las notificaciones")}
        </Paragraph>
      )}

      <Space
        direction="horizontal"
        style={
          isMobile ? {width: "100%", justifyContent: "center", display: "flex"} : {marginBottom: "20px", gap: "40px"}
        }
      >
        <SecondaryButton onClick={onClose}>{t("notifications.prompt.later", "Más tarde")}</SecondaryButton>
        <PrimaryButton
          loading={isSubscribing}
          onClick={onRequestPermission}
        >
          <img
            src={iconBellBlack}
            alt="Bell"
            style={{width: "22px", height: "23px"}}
          />
          {isSubscribing
            ? t("notifications.prompt.activating", "Activando...")
            : t("notifications.prompt.enable", "Activar notificaciones")}
        </PrimaryButton>
      </Space>
    </Space>
  );
};

NotificationPrompt.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onRequestPermission: PropTypes.func.isRequired,
  pushSupported: PropTypes.bool.isRequired,
  userConsent: PropTypes.string,
  isSubscribing: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default NotificationPrompt;
